const button = "_35sb1w6ky75";
const stateBox = "_35ssfq894x";

export { button, stateBox };
import "./input.word.style.linaria.module.css";
//# sourceMappingURL=input.word.style.js.map
